import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  errorMessage: string | undefined;

  loginForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService
  ) {
    this.loginForm = this.fb.group({
      login: ['', Validators.required],
      password: ['', Validators.required],
    });
  }

  ngOnInit(): void {}

  async onSubmit(): Promise<void> {
    //  console.log('submitted', this.loginForm.value);
    this.errorMessage = undefined;
    try {
      await this.authService.login(
        this.loginForm.value.login || '',
        this.loginForm.value.password || ''
      );
      this.router.navigate([this.authService.redirectionUrl]);
      this.authService.redirectionUrl = '/';
    } catch (error: any) {
      console.error(error);
      this.errorMessage = error.message || 'Login failed. Please check your credentials.';
    }
  }
}
